import React, { useEffect, useState } from "react";
import { isValidIsraeliId } from "../../utils/israeliId";

// ملاحظة عربية
import { create, update, getUserById as getOne, /*softDelete,*/ deleteU, uploadPhoto, deletePhoto } from "../../WebServer/services/user/functionsUser.jsx";
import styles from "./Profile.module.css";
import sectionStyles from "../UI/FormSection.module.css";
import { toast } from "../../ALERT/SystemToasts.jsx";
import {validate as validateINV, submit as submitFromParent} from "../../WebServer/services/inviteToken/functionInviteToken.jsx";
import { getMe } from "../../WebServer/services/auth/fuctionsAuth.jsx";
import { photoAction } from "../../utils/photoChange";
import { passportSrc, PASSPORT_PREVIEW } from "../../utils/passportPhoto";
import { usePhotoPick, PHOTO_NOT_READY } from "../../utils/photoPick";
import { getStoredPermissions } from "../../utils/session";
import MyPermissions from "./MyPermissions.jsx";
import ChangeOwnPassword from "./ChangeOwnPassword.jsx";
import PasskeyOffer from "../Auth/PasskeyOffer.jsx";
import { passkeySupported } from "../../utils/passkey";
import PhoneNotifications from "./PhoneNotifications.jsx";
import MyDevices from "./MyDevices.jsx";

const Profile = ({parent = false}) => {
    const [form, setForm] = useState({
        tz: "",
        password: "",
        firstname: "",
        lastname: "",
        birth_date: "", // ملاحظة عربية
        gender: "",
        phone: "",
        email: "",
        city: "",
        street: "",
        photo: null,
    });

    const [photo, setPhoto] = useState(null);
    // The photo link currently stored on the server; saving only touches it
    // when a new file was picked or the photo was removed.
    const [originalPhoto, setOriginalPhoto] = useState(null);
    const [error, setError] = useState({
        tz: "",
        password: "",
        firstname: "",
        lastname: "",
        birth_date: "", // ملاحظة عربية
        gender: "",
        phone: "",
        email: "",
        city: "",
        street: "",
    })

    const [loading, setLoading] = useState(false);
    const [saving, setSaving]   = useState(false);
    const [err, setErr]         = useState(null);
    const [myPermissions, setMyPermissions] = useState(getStoredPermissions);


    useEffect(() => {
        (async () => {
        try {
            //console.log("load training");
            setLoading(true);
            setErr(null);
            const res = await getMe(); // ملاحظة عربية
            if (res) {
                const s = res;
                delete s.password;
                delete s.createdAt;
                delete s.updatedAt;
                delete s.__v;
                delete s.roles;
                // Shown read-only below; never part of the profile form.
                if (Array.isArray(s.permissions)) setMyPermissions(s.permissions);
                delete s.permissions;
                delete s.role;
                delete s.permissionGrants;
                delete s.permissionRevokes;
                delete s.isSystem;
                setForm(s);
                setPhoto(s.photo || null);
                setOriginalPhoto(s.photo || null);
            } else {
            setErr("تعذّر تحميل البيانات");
            }
        } catch (e) {
            setErr("تعذّر تحميل البيانات");
        } finally {
            setLoading(false);
        }
        })();
    }, []);


    const photoPick = usePhotoPick(setPhoto, toast.warn);
    const handlePhoto = (e) => photoPick.pick(e.target.files[0]);
    const handleDeletePhoto = async () => {
        if (!photo) return;
        photoPick.cancel();
        setPhoto(null);
    }
    const handleDeletePhotoWithSave = async () => {
        try {
            const res = await deletePhoto(form.tz);
            if (!res || !res.ok) throw new Error(res?.message || "تعذّر حذف الصورة");
            setPhoto(null);
            toast.success("تم حذف الصورة بنجاح");
            return true;
        } catch (e) {
            toast.error(e.message || "تعذّر حذف الصورة");
            return false;
        }
    };


    const handleChange = async(e) => {
        const { name, value } = e.target;
        // ملاحظة عربية
        setForm((prev) => ({ ...prev, [name]: value }));
        const msg = await validate(name, value);
        setError((prev) => ({ ...prev, [name]: msg }));
    };

    const validate = async(name = null, value = null) => {
        const tag = document.getElementsByName(name)[0];
        if(name === "tz"){
            if (value === "") {
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "هذا الحقل مطلوب";
            } 
            else if(!isValidIsraeliId(value)){
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "رقم الهوية غير صالح"
            }
            tag?.style.setProperty('border', '2px solid green'); // ملاحظة عربية
            return ""
        }

        //fisrtname, lastname
        else if(['firstname', 'lastname', 'father_name', 'mother_name'].includes(name)){
            if (value === "") {
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "هذا الحقل مطلوب";
            } 
            else{
            tag?.style.setProperty('border', '2px solid green'); // ملاحظة عربية
            return ""
            }
        }

        //gender, role
        else if(['gender', 'roles'].includes(name)){
            if (name === 'gender' && !['ذكر' , 'انثى'].includes(value)) {
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "اختر الجنس";
            } else if (name === 'role' && !['ادارة', 'مرشد', 'مساعد'].includes(value)) {
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "اختر الدور";
            }  
            else{
            tag?.style.setProperty('border', '2px solid green'); // ملاحظة عربية
            return ""
            }
        }

        else if (name === "birth_date"){
            try{
            //console.log("birth_date", value, form.birth_date);
            if(value !== ""){
                const date = new Date(value); 
            }
            else {
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "اختر تاريخ الميلاد";
            }
            } catch {
            //console.log("invalid date");
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "تاريخ غير صالح";
            }
        }

        //phone, email, city, street
        else if (['father_phone', 'mother_phone', 'phone', 'email', 'city', 'street'].includes(name)){
            if (value === "") {
            tag?.style.setProperty('border', '2px solid red'); // ملاحظة عربية
            return "هذا الحقل مطلوب";
            } 
            else{
            tag?.style.setProperty('border', '2px solid green'); // ملاحظة عربية
            return ""
            }
        }
        else if (name === "roles") {
            if (!value || value.length === 0) return "اختر دورًا واحدًا على الأقل";
            return "";
        }

        return ""; 
    }

    const normalizePhoneToIntl = (val) => {
        if (!val) return '';
        let v = String(val).replace(/\D+/g, '');
        // ملاحظة عربية
        if (v.startsWith('972')) v = '+' + v;
        // ملاحظة عربية
        if (v.startsWith('0')) v = '+972' + v.slice(1);
        if (!v.startsWith('+')) v = '+' + v;
        return v;
    };

    const displayPhoneLocal = (val) => {
        if (!val) return '';
        let v = String(val);
        if (v.startsWith('+972')) v = '0' + v.slice(4);
        return v.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // 05x-xxx-xxxx
    };

    const onField = async(e) => {
        const { name, value } = e.target;
        //console.log(`onField[${name}] = ${String(value)}`, value === '');
        setForm((prev) => ({ ...prev, [name]: value }));
        const msg = await validate(name, value)
        // //console.log("msg", msg);
        setError((prev) => ({ ...prev, [name]: msg }));
    };

    const onPhoneChange = (tag, text) => {
        const local = text.replace(/[^\d-]/g, '');
        const intl = normalizePhoneToIntl(local);
        setForm((prev) => ({ ...prev, [tag]: intl }));
    };

    const handleSubmit = async (e) => {
        if (photoPick.busy) { toast.warn(PHOTO_NOT_READY); return; }
        let b = await validate();
        if (b) { toast.warn(b); return; }
        b = true
        const ff = ['tz', 'firstname', 'lastname', 'birth_date', 'gender', 'phone', 'email', 'city', 'street'];
        for(const nameTag in ff){
            const tag = document.getElementsByName(ff[nameTag])[0];
            //console.log('Tag', tag, ff[nameTag]);
            console.log('tag', tag);
            const msg = await validate(tag.name, tag.value);
            setError((prev) => ({ ...prev, [tag.name]: msg }));
            // //console.log('msg', msg)
            if(msg && msg !== ''){
                b = false;
            }
        }
        if(!b) return toast.warn("يُرجى تعبئة الحقول المطلوبة");
        e.preventDefault();
        try {
            setSaving(true);
            setErr(null);

            const payload = { ...form };
            // One's own password changes only in the "change password" section.
            delete payload.password;
            //console.log("payload", payload);  
            if(parent && !inviteToken){
                toast.error("رابط التسجيل غير صالح.");
                return;
            }
            
            // The photo only changes through its own endpoints, which keep the
            // stored link and the Drive file in sync, and only when the user
            // actually picked a new file or removed it.
            delete payload.photo;
            const photoChange = photoAction(originalPhoto, photo);

            const res = await update(form.tz, payload);
            if(!res) return;
            if(!res.ok) throw new Error(res.message);
            toast.success("تم حفظ الملف الشخصي بنجاح");

            if (photoChange === "remove" && await handleDeletePhotoWithSave()) {
                setOriginalPhoto(null);
            }
            if (photoChange === "upload") {
                const res2 = await uploadPhoto(form.tz, photo);
                if(!res2) return;
                if(!res2.ok) {
                    toast.warn("تعذّر رفع الصورة: " + res2.message);
                }
                else{
                    setPhoto(res2.photo || null);
                    setOriginalPhoto(res2.photo || null);
                    toast.success("تم رفع الصورة بنجاح");
                }
            }
        } catch (e) {
            console.error(e);
            toast.error(e.message || "تعذّر إتمام العملية");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className={styles.formContainer}>جارٍ تحميل البيانات…</div>;
    if (err)      return <div className={styles.formContainer} style={{color:"#b91c1c"}}>{err}</div>;


    return (
        <div className={styles.formContainer}>
        <h2>الملف الشخصي</h2>

        <fieldset className={sectionStyles.formSection} data-tour="profile-account">
            <legend>بيانات الحساب</legend>
            <label>رقم الهوية:</label>
            <input name="tz" value={form.tz} onChange={onField} readOnly={true} />
            <label style={{color: "red"}}>{error.tz}</label>

        </fieldset>

        <ChangeOwnPassword />
        {passkeySupported() && <PasskeyOffer always />}

        <PhoneNotifications />

        <MyDevices />

        <fieldset className={sectionStyles.formSection} data-tour="profile-personal">
            <legend>البيانات الشخصية</legend>
            <label>الاسم الشخصي:</label>
            <input name="firstname" value={form.firstname} onChange={handleChange} required />
            <label style={{color: "red"}}>{error.firstname}</label>

            <label>اسم العائلة:</label>
            <input name="lastname" value={form.lastname} onChange={handleChange} required />
            <label style={{color: "red"}}>{error.lastname}</label>

            <label>تاريخ الميلاد:</label>
            <input
                name="birth_date"
                type="date"
                value={form.birth_date ? String(form.birth_date).slice(0, 10) : ''}
                onChange={onField}
            />
            <label style={{color: "red"}}>{error.birth_date}</label>

            <label>الجنس:</label>
            <select name="gender" value={form.gender} onChange={onField}>
                <option value="">اختر الجنس</option>
                <option value="ذكر">ذكر</option>
                <option value="انثى">أنثى</option>
            </select>
            <label style={{color: "red"}}>{error.gender}</label>
        </fieldset>

        <fieldset className={sectionStyles.formSection}>
            <legend>السكن والتواصل</legend>
            <label>مدينة السكن:</label>
            <input name="city" value={form.city} onChange={onField} />
            <label style={{color: "red"}}>{error.city}</label>

            <label>شارع السكن:</label>
            <input name="street" value={form.street} onChange={onField} />
            <label style={{color: "red"}}>{error.street}</label>

            <label>الهاتف:</label>
            <input
                name="phone"
                value={displayPhoneLocal(form.phone)}
                onChange={(e)=>onPhoneChange('phone', e.target.value)}
                placeholder="052-123-4567"
            />
            <label style={{color: "red"}}>{error.phone}</label>

            <label>البريد الإلكتروني:</label>
            <input name="email" value={form.email} onChange={onField} />
            <label style={{color: "red"}}>{error.email}</label>
        </fieldset>

        <div style={{ marginBottom: "16px" }} data-tour="profile-photo">
            <label>الصورة الشخصية:</label>
            <button onClick={
            ()=> {
                const input = document.createElement('input');
                input.type = "file";
                input.accept = "image/*"
                input.onchange = handlePhoto;
                input.click();
            }
            }> {photo ? "تغيير الصورة" : "اختر صورة"} </button>
            {photo && (
                <button type="button" onClick={handleDeletePhoto} style={{ marginInlineStart: "8px" }}>
                    حذف الصورة
                </button>
            )}
            <br />

            {/* معاينة الصورة إذا موجودة */}
            {photo && (
            <img
                src={photo instanceof File ? URL.createObjectURL(photo) : passportSrc(photo)}
                alt="preview"
                style={PASSPORT_PREVIEW}
            />
            )}
        </div>

        {/* <MyPermissions permissions={myPermissions} /> */}

        <div className={styles.buttonRow} style={{ gap: 8, flexWrap: "wrap" }}>
            <button type="submit" data-tour="profile-save" onClick={handleSubmit}>
            {saving ? "جارٍ الحفظ…" : "حفظ التعديلات"}
            </button>
        </div>
        </div>
    );
};

export default Profile;
